<template>
  <div>
    <AppHeader />
    <main v-if="currentLeg" class="flex flex-col justify-center text-center">
      <h1 class="font-heading font-semibold text-3xl pt-4 pb-3 select-none">
        Test Leg
      </h1>
      <Game
        :key="legNumber"
        :settings="gameSettings"
        nextButtonText="Restart"
        @nextLeg="nextLeg"
      />
    </main>
    <main
      v-else
      class="h-full flex flex-col justify-center items-center text-center"
    >
      <h1 class="font-heading font-semibold text-5xl py-8 select-none">
        Error: Problem in Leg Settings
      </h1>
      <div>
        <router-link to="/" class="button inline-block mx-3"
          >Return Home</router-link
        >
        <button
          class="button-secondary inline-block mx-3"
          @click="$router.go(-1)"
        >
          Back
        </button>
      </div>
    </main>
  </div>
</template>
<script>
import AppHeader from '@/components/AppHeader'
import Game from '@/components/Game'

export default {
  components: {
    AppHeader,
    Game,
  },

  data: function () {
    return {
      legNumber: 1,
    }
  },

  computed: {
    currentLeg: function () {
      try {
        const {
          image,
          scale,
          start,
          finish,
          compulsoryPoints,
          disallowedPoints,
          correctPath,
        } = this.$route.query

        return {
          scale: JSON.parse(scale),
          startLocation: JSON.parse(start),
          finishLocation: JSON.parse(finish),
          compulsoryPoints: JSON.parse(compulsoryPoints),
          disallowedPoints: JSON.parse(disallowedPoints),
          correctPath: JSON.parse(correctPath),
          imageLocation: image,
        }
      } catch {
        return false
      }
    },

    gameSettings: function () {
      return {
        ...this.currentLeg,
        imageLocation: this.$route.query.image,
        showCorrectRoute: true,
        hideMap: false,
        penalty: undefined,
        timeLimit: undefined,
        undoButton: true,
        undoPenalty: 0,
      }
    },
  },

  methods: {
    nextLeg: function () {
      this.legNumber += 1
    },
  },
}
</script>
